import script from "./PhishingView.vue?vue&type=script&setup=true&lang=js"
export * from "./PhishingView.vue?vue&type=script&setup=true&lang=js"

import "./PhishingView.vue?vue&type=style&index=0&id=0ff4514a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ff4514a"]])

export default __exports__